import { captureException } from "@sentry/react"

import { createCaptureError } from "@productlane/lib"

export const captureError = createCaptureError(captureException, "app")
